var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 536,
    viewBox: "0 0 377 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 204.5C504 317.442 412.442 409 299.5 409C186.558 409 95 317.442 95 204.5C95 91.5578 186.558 0 299.5 0C412.442 0 504 91.5578 504 204.5Z",
    fill: "#F2F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246 535.146C381.39 535.146 491.146 425.39 491.146 290C491.146 154.61 381.39 44.8542 246 44.8542C110.61 44.8542 0.854167 154.61 0.854167 290C0.854167 425.39 110.61 535.146 246 535.146ZM246 536C381.862 536 492 425.862 492 290C492 154.138 381.862 44 246 44C110.138 44 0 154.138 0 290C0 425.862 110.138 536 246 536Z",
    fill: "#FFCC80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1365 196.518C80.1365 198.461 78.5391 200.036 76.5685 200.036C74.5979 200.036 73.0005 198.461 73.0005 196.518C73.0005 194.575 74.5979 193 76.5685 193C78.5391 193 80.1365 194.575 80.1365 196.518Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1361 234.927C80.1361 236.869 78.5386 238.445 76.568 238.445C74.5975 238.445 73 236.869 73 234.927C73 232.984 74.5975 231.409 76.568 231.409C78.5386 231.409 80.1361 232.984 80.1361 234.927Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1361 273.914C80.1361 275.856 78.5386 277.432 76.568 277.432C74.5975 277.432 73 275.856 73 273.914C73 271.971 74.5975 270.396 76.568 270.396C78.5386 270.396 80.1361 271.971 80.1361 273.914Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1361 312.904C80.1361 314.846 78.5386 316.421 76.568 316.421C74.5975 316.421 73 314.846 73 312.904C73 310.961 74.5975 309.386 76.568 309.386C78.5386 309.386 80.1361 310.961 80.1361 312.904Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09 197.102C119.09 199.045 117.493 200.62 115.522 200.62C113.552 200.62 111.954 199.045 111.954 197.102C111.954 195.159 113.552 193.584 115.522 193.584C117.493 193.584 119.09 195.159 119.09 197.102Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09 235.506C119.09 237.449 117.493 239.024 115.522 239.024C113.552 239.024 111.954 237.449 111.954 235.506C111.954 233.563 113.552 231.988 115.522 231.988C117.493 231.988 119.09 233.563 119.09 235.506Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09 274.495C119.09 276.438 117.493 278.013 115.522 278.013C113.552 278.013 111.954 276.438 111.954 274.495C111.954 272.552 113.552 270.977 115.522 270.977C117.493 270.977 119.09 272.552 119.09 274.495Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09 313.482C119.09 315.425 117.493 317 115.522 317C113.552 317 111.954 315.425 111.954 313.482C111.954 311.539 113.552 309.964 115.522 309.964C117.493 309.964 119.09 311.539 119.09 313.482Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.046 197.102C158.046 199.045 156.448 200.62 154.478 200.62C152.507 200.62 150.91 199.045 150.91 197.102C150.91 195.159 152.507 193.584 154.478 193.584C156.448 193.584 158.046 195.159 158.046 197.102Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.046 235.506C158.046 237.449 156.448 239.024 154.478 239.024C152.507 239.024 150.91 237.449 150.91 235.506C150.91 233.563 152.507 231.988 154.478 231.988C156.448 231.988 158.046 233.563 158.046 235.506Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.046 274.495C158.046 276.438 156.448 278.013 154.478 278.013C152.507 278.013 150.91 276.438 150.91 274.495C150.91 272.552 152.507 270.977 154.478 270.977C156.448 270.977 158.046 272.552 158.046 274.495Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.046 313.482C158.046 315.425 156.448 317 154.478 317C152.507 317 150.91 315.425 150.91 313.482C150.91 311.539 152.507 309.964 154.478 309.964C156.448 309.964 158.046 311.539 158.046 313.482Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 196.519C197 198.462 195.403 200.037 193.432 200.037C191.461 200.037 189.864 198.462 189.864 196.519C189.864 194.576 191.461 193.001 193.432 193.001C195.403 193.001 197 194.576 197 196.519Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 234.927C197 236.869 195.402 238.445 193.432 238.445C191.461 238.445 189.864 236.869 189.864 234.927C189.864 232.984 191.461 231.409 193.432 231.409C195.402 231.409 197 232.984 197 234.927Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 273.913C197 275.856 195.402 277.431 193.432 277.431C191.461 277.431 189.864 275.856 189.864 273.913C189.864 271.97 191.461 270.395 193.432 270.395C195.402 270.395 197 271.97 197 273.913Z",
    fill: "#4CB963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 312.904C197 314.846 195.402 316.421 193.432 316.421C191.461 316.421 189.864 314.846 189.864 312.904C189.864 310.961 191.461 309.386 193.432 309.386C195.402 309.386 197 310.961 197 312.904Z",
    fill: "#4CB963"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles2);
export default __webpack_public_path__ + "static/media/bubbles-2.10bf4509ccb0d5b215cda3d7d058fc51.svg";
export { ForwardRef as ReactComponent };